"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(require("./ListItemText"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListItemText/index.js
// module id = 232
// module chunks = 212839066777427 261807626633106